<video
  id="video-{{id}}"
  [poster]="poster"
  controls
  [autoplay]="playVideo"
  [muted]="true"
  loop>
</video>
